import store from '../store/Store';
import actionTypes from '../actionTypes/actionTypes';

async function openMenu() {
	const action = {
		type: actionTypes.OPEN_MENU
	};

	store.dispatch(action);
}

async function closeMenu() {
	const action = {
		type: actionTypes.CLOSE_MENU
	};

	store.dispatch(action);
}

async function setEditorSelectedPage(pageIndex) {
	const action = {
		type: actionTypes.SET_EDITOR_SELECTED_PAGE,
		data: pageIndex
	};

	store.dispatch(action);	
}

async function setEditorPreviousPage(pageIndex) {
	const action = {
		type: actionTypes.SET_EDITOR_PREVIOUS_PAGE,
		data: pageIndex
	};

	store.dispatch(action);	
}

async function setEditorTitle(title) {
	const action = {
		type: actionTypes.SET_EDITOR_TITLE,
		data: title
	};

	store.dispatch(action);	
}

async function addEditorPage(pageIndex) {
	const action = {
		type: actionTypes.ADD_EDITOR_PAGE,
		data: pageIndex
	};

	store.dispatch(action);	
}

async function removeEditorPage(pageIndex) {
	const action = {
		type: actionTypes.REMOVE_EDITOR_PAGE,
		data: pageIndex
	};

	store.dispatch(action);	
}

const editorActions = {
	openMenu,
	closeMenu,
	setEditorSelectedPage,
	setEditorPreviousPage,
	setEditorTitle,
	addEditorPage,
	removeEditorPage
}

export default editorActions;